import React, { useEffect } from "react";
import { StyleSheet } from "react-native";
import { genderList } from "src/constant";
import { FormControlLabel } from "src/components";
import { colors } from "src/assets";
import { EventRegister } from "react-native-event-listeners";
import { navigationRef } from "src/hooks/navigation";
import { Gender } from "src/domains";
import LocalText from "src/local";

export type GenderControlProps = {
  value?: string;
  error?: string;
  onChange: (value: Gender) => void;
};

const buildDetail = (v?: string) => {
  let text = "";
  if (v) {
    let index = genderList.findIndex((item) => item.key === v);
    if (index !== -1) {
      text = genderList[index].label;
    }
  }

  return text || LocalText.common.unselected;
};

export const GenderControl: React.FC<GenderControlProps> = ({
  value,
  error,
  onChange,
}) => {
  useEffect(() => {
    const myPageGenderListener = EventRegister.addEventListener(
      "MyPageGender",
      (v: Gender) => onChange(v)
    );
    return () => {
      EventRegister.removeEventListener(myPageGenderListener as string);
    };
  }, [onChange]);

  return (
    <FormControlLabel
      text={LocalText.screens.myProfile.genderControl.title}
      detailStyle={[value ? styles.detail : {}]}
      detail={buildDetail(value)}
      rightIcon={"chevron"}
      error={error}
      onPress={() => {
        navigationRef.current?.navigate("CustomSelectionList", {
          eventName: "MyPageGender",
          title: LocalText.screens.myProfile.genderControl.title,
          selectedId: value,
          items: genderList.map((item) => ({
            id: item.key,
            label: item.label,
          })),
        });
      }}
    />
  );
};

const styles = StyleSheet.create({
  detail: {
    color: colors.chokuBlack,
  },
});
